import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "searchInput",
    "affiliateRow",
    "affiliateCheckbox",
    "affiliateCount",
    "summary",
    "submitButton",
  ]

  connect() {
    this.updateSummary()
  }

  filter() {
    const query = this.searchInputTarget.value.trim().toLowerCase()

    this.affiliateRowTargets.forEach((row) => {
      const show = query === "" || (row.dataset.name || "").includes(query)
      row.classList.toggle("d-none", !show)
    })
  }

  selectAll() {
    this.affiliateCheckboxTargets.forEach((checkbox) => {
      if (!checkbox.closest(".d-none")) checkbox.checked = true
    })
    this.updateSummary()
  }

  clearAll() {
    this.affiliateCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.updateSummary()
  }

  updateSummary() {
    const count = this.affiliateCheckboxTargets.filter((checkbox) => checkbox.checked).length
    this.affiliateCountTarget.textContent = `${count} selected`
    this.affiliateCountTarget.classList.toggle("bg-primary", count > 0)
    this.affiliateCountTarget.classList.toggle("bg-secondary", count === 0)
    this.submitButtonTarget.disabled = count === 0
    this.summaryTarget.textContent = count > 0 ?
      `Selected ${count} affiliate${count === 1 ? "" : "s"} for the pending invitees.` :
      "Select affiliates to assign to the invited users."
  }
}
